import { useCallback } from "react";
import { useDispatch } from "react-redux";

import SetAdvisor from "data/advisor/actions";
import useCurrentUser from "data/advisor/useCurrentUser";
import { SetAdvisorPreferences } from "data/libs/advisor";

import { useAsyncCall } from "hooks";
import { SetAlert } from "components/Alerts/actions";

export function useUpdateWorkDeskPreference() {
  const dispatch = useDispatch();
  const user = useCurrentUser();
  const [call, loading] = useAsyncCall();

  // Read the advisor from the store at completion time so an in-flight update
  // to another field is not clobbered by the render-time snapshot.
  const onUpdateCompleted = useCallback(
    (preferences) => {
      dispatch((innerDispatch, getState) => {
        const advisor = getState()?.hubly?.data?.advisor;
        innerDispatch(SetAdvisor({ ...advisor, preferences }));
      });
    },
    [dispatch]
  );

  return {
    isUpdating: loading,
    updateWorkDeskPreference: async (enabled) => {
      return call(async () => {
        try {
          const preferences = await SetAdvisorPreferences(user?.id, {
            key: "work-desk",
            value: enabled,
          });

          onUpdateCompleted(preferences);

          return preferences;
        } catch (e) {
          dispatch(
            SetAlert({
              type: "error",
              text: "Failed to update Work Desk. Please try again.",
            })
          );
          console.error("Error updating Work Desk preference", e);

          return null;
        }
      });
    },
  };
}

export default useUpdateWorkDeskPreference;
